import { Box, lighten } from '@mui/material';
import React from 'react';

interface ProgressBarProps {
  color: string;
  pct: number;
  delay?: number; // kept for backwards compatibility but not used
  onMouseEnter?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  onMouseLeave?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

export const ProgressBar = React.forwardRef<HTMLDivElement, ProgressBarProps>(
  function ProgressBar({ color, pct, delay, ...rest }, ref) {
    // Directly use pct prop, no internal state needed
    const width = `${Math.max(0, Math.min(100, 100 * pct))}%`;

    return (
      <Box
        ref={ref}
        {...rest}
        sx={{
          flexGrow: 0,
          flexShrink: 0,
          height: '100%',
          backgroundColor: color,
          transition: 'width 250ms ease-out',
          width,
          zIndex: 0,
          '&:hover': {
            backgroundColor: lighten(color, 0.3),
            cursor: rest.onMouseEnter && rest.onMouseLeave && 'pointer',
          },
        }}
      />
    );
  },
);
